<template>
  <div class="results__loader-wrapper">
    <div class="icon-loader utility-pulse"></div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.component("Loading", {
  props: {
    loading: Boolean,
  },
});
</script>
